// src/components/modals/BaseModalWeb.jsx

import Modal from 'react-modal';

Modal.setAppElement('#root');

const BaseModalWeb = ({
  isOpen,
  onRequestClose,
  contentLabel = 'Modal Window',
  className = 'ReactModal__Content modal--web',
  overlayClassName = 'ReactModal__Overlay modal-overlay--web',
  children,
}) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    shouldCloseOnOverlayClick={true}
    shouldCloseOnEsc={true}
    contentLabel={contentLabel}
    className={className}
    overlayClassName={overlayClassName}
  >
    {children}
  </Modal>
);

export default BaseModalWeb;